export default "__VITE_ASSET__DUWF_N4y__"